// GENERATED FILE -- do not edit by hand.
// Regenerate with `npm run codegen:stores` (see frontend/package.json).
// Source: agent.app.repository.managed.managed_repository.ManagedRepository

import { makeObservable, observable } from "mobx";
import { applyJsonPatch, JsonPatchOp } from "@/app_store/rpc/json_patch";
import { AgentTransport, callRpc } from "@/app_store/rpc/rpc";
import { registerEntity, wrapEntity } from "@/app_store/rpc/entity";
import { SandboxData, SandboxStore } from "./Sandbox.generated";
import { ManagedRepositoryWorkspaceData, ManagedRepositoryWorkspaceStore } from "./ManagedRepositoryWorkspace.generated";

export interface ManagedRepositoryData {
    // Stamped onto every @observable model's dump at runtime (see
    // common._ObservableMixin._serialize_with_tag) -- tells wrapEntity which
    // generated Store class this value belongs to. Never sent by a client.
    _entity_class_name: "ManagedRepository";
    sandbox: SandboxData | null;
    path: string;
    workspace: ManagedRepositoryWorkspaceData | null;
    branches: string[];
    active_key: string | null;
    url: string;
}

export class ManagedRepositoryStore {
    readonly _entity_class_name = "ManagedRepository" as const;
    sandbox: SandboxStore | null;
    path: string;
    workspace: ManagedRepositoryWorkspaceStore | null;
    branches: string[];
    active_key: string | null;
    url: string;
    private _transport: AgentTransport;
    private _chainPath: string[];

    constructor(data: ManagedRepositoryData, transport: AgentTransport, chainPath: string[] = []) {
        this._transport = transport;
        this._chainPath = chainPath;
        this.sandbox = wrapEntity(data.sandbox, transport, [...chainPath, "sandbox"]) ?? null;
        this.path = wrapEntity(data.path, transport, [...chainPath, "path"]);
        this.workspace = wrapEntity(data.workspace, transport, [...chainPath, "workspace"]) ?? null;
        this.branches = wrapEntity(data.branches, transport, [...chainPath, "branches"]);
        this.active_key = wrapEntity(data.active_key, transport, [...chainPath, "active_key"]) ?? null;
        this.url = wrapEntity(data.url, transport, [...chainPath, "url"]);
        makeObservable(this, {
            sandbox: observable,
            path: observable,
            workspace: observable,
            branches: observable,
            active_key: observable,
            url: observable,
        });
    }

    applyPatch(op: JsonPatchOp): void {
        applyJsonPatch(this, op);
    }

    async list_managed_branches(): Promise<any> {
        return callRpc(this._transport, this._chainPath, "list_managed_branches", [], {});
    }

    async use_key(name: any): Promise<any> {
        return callRpc(this._transport, this._chainPath, "use_key", [name], {});
    }

    async select_branch(branch: any): Promise<any> {
        return callRpc(this._transport, this._chainPath, "select_branch", [branch], {});
    }

    async create_branch(name: any): Promise<any> {
        return callRpc(this._transport, this._chainPath, "create_branch", [name], {});
    }
}

registerEntity("ManagedRepository", ManagedRepositoryStore);
